import { Crown, Wine, MapPin, MessagesSquare } from "lucide-react";
import { ChapterLabel, Reveal } from "@/components/landing/Reveal";

const FEATURES = [
    {
        icon: Crown,
        title: "VIP Tables",
        copy: "Reserve premium tables at top nightlife venues.",
        testId: "feature-vip-tables",
    },
    {
        icon: Wine,
        title: "Bottle Service",
        copy: "Choose packages that match your group and occasion.",
        testId: "feature-bottle-service",
    },
    {
        icon: MapPin,
        title: "Prime Locations",
        copy: "Get access to premium table locations where available.",
        testId: "feature-prime-locations",
    },
    {
        icon: MessagesSquare,
        title: "Personal Concierge",
        copy: "Get assistance through WhatsApp before and during your booking.",
        testId: "feature-personal-concierge",
    },
];

const Features = () => (
    <section
        id="vip-tables"
        data-testid="features-section"
        className="border-y border-white/10 bg-[#0A0A0A]"
    >
        <div className="mx-auto max-w-7xl px-5 py-24 md:px-10 md:py-36">
            <Reveal>
                <ChapterLabel number="Nº 02" title="The Service" testId="features-label" />
            </Reveal>
            <Reveal delay={0.1}>
                <h2 className="mt-8 max-w-3xl font-serif text-3xl font-medium leading-tight tracking-tight text-ivory md:text-5xl">
                    YOUR NIGHT. YOUR TABLE.{" "}
                    <span className="italic text-gold">YOUR WAY.</span>
                </h2>
            </Reveal>

            <div className="mt-16 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
                {FEATURES.map((f, i) => (
                    <Reveal key={f.title} delay={0.1 + i * 0.08} className="h-full">
                        <div
                            data-testid={f.testId}
                            className="group flex h-full flex-col justify-between gap-10 rounded-sm border border-white/10 bg-[#0F0F0F] p-8 transition-colors duration-500 hover:border-gold/40"
                        >
                            <div className="flex items-start justify-between">
                                <f.icon
                                    size={28}
                                    strokeWidth={1.25}
                                    className="text-gold"
                                />
                                <span className="font-serif text-lg italic text-white/15 transition-colors duration-500 group-hover:text-gold/40">
                                    0{i + 1}
                                </span>
                            </div>
                            <div>
                                <h3 className="text-xs font-bold uppercase tracking-[0.25em] text-ivory">
                                    {f.title}
                                </h3>
                                <p className="mt-3 text-sm leading-relaxed text-muted">
                                    {f.copy}
                                </p>
                            </div>
                        </div>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);

export default Features;
